// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3JODc","container":"styles_container__2qHk8","title":"styles_title__1DuhM","wrapper":"styles_wrapper__1h05I","answer":"styles_answer__3zbjf"};